<div class="container">

  <form [formGroup]="potForm">

    <div class="row" *ngIf="isEdit">
      <h2 class="display-6" style="margin-bottom:0%">Gear Name</h2>
    </div>

    <div class="row" *ngIf="isEdit">
      <div class="col">
        <div class="row">
          <mat-form-field style="font-weight: bold;">
            <mat-label>Name</mat-label>
            <input matInput type="text" formControlName="name">
            <mat-hint>Leave blank to auto letter gear</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>

    <br>
    <br>

    <div class="row">
      <h2 class="display-6" style="margin-bottom:0%">Pot Type</h2>
    </div>

    <br>

    <div class="row">
      <mat-form-field>
        <mat-select formControlName="potType" [compareWith]="compareFn" required>
          <mat-option *ngFor="let type of potTypes" [value]="type">
            {{type}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="potForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <br>

    <div class="row">
      <h2 class="display-6" style="margin-bottom:0%">Pot Size</h2>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <mat-form-field style="font-weight: bold;">
            <mat-label>Height (feet)</mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="height" (input)="_forbidNonNumeric(potForm.get('height')!)" required>
            <mat-error *ngIf="potForm.invalid">Required</mat-error>
          </mat-form-field>
        </div>
      </div>


      <div class="col">
        <div class="row">
          <mat-form-field style="font-weight: bold;">
            <mat-label>Width (feet)</mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="width" (input)="_forbidNonNumeric(potForm.get('width')!)" required>
            <mat-error *ngIf="potForm.invalid">Required</mat-error>
          </mat-form-field>
        </div>
      </div>


      <div class="col">
        <div class="row">
          <mat-form-field style="font-weight: bold;">
            <mat-label>Length (feet)</mat-label>
            <input matInput type="text" inputmode="decimal" formControlName="length" (input)="_forbidNonNumeric(potForm.get('length')!)" required>
            <mat-error *ngIf="potForm.invalid">Required</mat-error>
          </mat-form-field>
        </div>
      </div>

    </div>

    <br>

    <div class="row">
      <h2 class="display-6" style="margin-bottom:0%">Pot/Barrel/Bucket Spacing</h2>
    </div>

    <div class="row">
      <mat-form-field style="font-weight: bold;">
        <mat-label>Feet apart on groundline</mat-label>
        <input matInput type="text" inputmode="decimal" formControlName="spacing" (input)="_forbidNonNumeric(potForm.get('spacing')!)" required>
        <mat-error *ngIf="potForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <h2 class="display-6" style="margin-bottom:0%">Escapement Hole Size</h2>
    </div>

    <div class="row">
      <mat-form-field style="font-weight: bold;">
        <mat-label>Inches</mat-label>
        <input matInput type="text" inputmode="decimal" formControlName="holeSize" (input)="_forbidNonNumeric(potForm.get('holeSize')!)" required>
        <mat-error *ngIf="potForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <h2 class="display-6" style="margin-bottom:0%">Number of Escapement Holes</h2>
    </div>


    <div class="row">
      <mat-form-field>
        <input matInput type="text" inputmode="decimal" formControlName="numHoles" (input)="_forbidNonNumeric(potForm.get('numHoles')!)" required>
        <mat-error *ngIf="potForm.invalid">Required</mat-error>
      </mat-form-field>
    </div>

  </form>

  <!-- Cancel or create pot gear -->
  <div class="row justify-content-between" style="margin-top: 50px;" align="center">
    <button mat-stroked-button
            class="text-blue-button"
            type="button"
            aria-label="confirm"
            (click)="cancelEvent.emit('Pot')">
      Cancel
    </button>

    <button mat-stroked-button
            class="text-button"
            type="submit"
            aria-label="confirm"
            (click)="onConfirmBtnClick()">
      OK
    </button>
  </div>

</div>
